import React, { Component } from 'react';
import { SplitButton, MenuItem, FormGroup, FormControl, Form } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import PropTypes from 'prop-types';

export default class Toolbar extends Component {

  static defaultProps = {
    page: 1,
    page_prev: false,
    page_next: false,
    page_limit: 25,
    keyword: '',
    onPageChange: () => {},
    onPageLimitChange: () => {},
    onKeywordChange: () => {},
  };

  propsTypes = {
    page: PropTypes.number,
    page_prev: PropTypes.number,
    page_next: PropTypes.number,
    page_limie: PropTypes.number,
    keyword: PropTypes.string,
    onPageChange: PropTypes.func,
    onPageLimitChange: PropTypes.func,
    onKeywordChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.handleZoomChange = this.handleZoomChange.bind(this);
  }

  handleZoomChange(e) {
    if (this.props.onZoomChange) {
      this.props.onZoomChange(e.target.value)
    }
  }
  print = () => {
    if (this.props.onPrintRequest) {
      this.props.onPrintRequest({});
    } else {
      document.getElementById('print-btn').click()
    }
  }
  showCompanyModal = () => {
    this.props.showCompanyModal()
  }
  onMenuItemSelect = (eventKey, event) => {
    if (typeof this.props.onDisplayOptionChanged !== 'undefined')
      this.props.onDisplayOptionChanged(eventKey)

    // if (eventKey === 'responsibleName') {
    //   alert('responsibleName')
    //   if (typeof this.props.onDisplayOptionChanged !== 'undefined')
    //     this.props.onDisplayOptionChanged()
    // }
  }

  renderStatus() {
    return [
      { label: 'รอเริ่มงาน', style: { color: 'grey' } },
      { label: 'กำลังซ่อม', style: { color: 'orange' } },
      { label: 'ซ่อมเสร็จในขั้นตอน', style: { color: 'blue' } },
      { label: 'หยุดชั่วคราว', style: { color: 'red' } }
    ].map((o, i) => (
      <FormGroup key={i}>
        <FontAwesome
          name='check-circle'
          style={o.style}
        />
        <FormControl.Static>
          {o.label}
        </FormControl.Static>
      </FormGroup>
    ))
  }

  onPageButtonClick = (direction) => e => {
    this.props.onPageChange(parseInt(this.props.page) + parseInt(direction));
  };
  onPageChange = (e) => { this.props.onPageChange(e.target.value); };
  onPageLimitChange = (e) => { this.props.onPageLimitChange(e.target.value); };
  onKeywordChange = (e) => { this.props.onKeywordChange(e.target.value); };

  render() {
    let zoomRadios = [
      { label: 'วัน', value: 'Hours' },
      { label: 'สัปดาห์', value: 'Days' },
      { label: 'เดือน', value: 'Months' }
    ].map((data) => {
      let isActive = this.props.zoom === data;
      return (
        <label key={data.value} className={`radio-label ${isActive ? 'radio-label-active' : ''}`}>
          <input type='radio'
            checked={isActive}
            onChange={this.handleZoomChange}
            value={data.value} />
          {data.label}
        </label>
      );
    });
    const menuItems = typeof this.props.displayOptions === 'undefined'
      ? null
      : this.props.displayOptions.map((option, index) => (
        <MenuItem key={index} eventKey={option.key}>{option.value}</MenuItem>
      ))
    const displayMode = menuItems === null
      ? null
      : <SplitButton
        bsStyle={'primary'}
        title={'แสดงผล'}
        id={'po-menu-options'}
        onSelect={this.onMenuItemSelect}
      >
        {menuItems}
      </SplitButton>

    return (
        <div className="zoom-bar" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
          }}>
            <b>มุมมอง: </b>
            {zoomRadios}
            <b className="manage-label">ค้นหา: </b>
            <input type="text" value={this.props.keyword}
                   className="form-control text-center d-inline-block"
                   style={{width: 120, display: 'inline-block'}}
                   onChange={this.onKeywordChange} />
            <b className="manage-label">จัดการ: </b>
            <button className="btn btn-primary" onClick={this.print}
                    type="button">
              <span className="fa fa-print" />{' '}
              พิมพ์
            </button>
            <b className="manage-label">หน้า: </b>
            <button type="button" className="btn btn-default"
                    disabled={!this.props.page_prev}
                    onClick={this.onPageButtonClick(-1)}>{'<<'}</button>
            <input type="number" value={this.props.page}
                   className="form-control text-center d-inline-block"
                   style={{width: 80, display: 'inline-block'}}
                   onChange={this.onPageChange} />
            <button type="button" className="btn btn-default"
                    disabled={!this.props.page_next}
                    onClick={this.onPageButtonClick(+1)}>{'>>'}</button>
            <b className="manage-label">แสดง: </b>
            <select value={this.props.page_limit}
                    className="form-control text-center d-inline-block"
                    style={{width: 100, display: 'inline-block'}}
                    onChange={this.onPageLimitChange}>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <b className="manage-label">รายการ</b>
          </div>

          <div>
          <Form inline>
            {this.renderStatus()}
            {displayMode}
          </Form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/view/workdoc/plan/Toolbar.js